import type { RecommendationExtension as Recommendation } from 'tio-data/data/resources/recommendation.ext';
import type { WellnessInsightsComponentDefinition } from './wellness-insights-component-definition.type.ts';

const matchesApp =
  (requestingApp: 'STRATEGY_FINDER' | 'PSLF' | 'IDR') =>
  (recommendation: Recommendation): boolean =>
    recommendation.requestingApp === requestingApp;

const byCreatedAt = (a: Recommendation, b: Recommendation): number =>
  new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();

// remains to be seen how important these are

// remains to be seen how important *these* are, too
export interface WellnessInsightsComponentDefinitionExtension extends WellnessInsightsComponentDefinition {}
export class WellnessInsightsComponentDefinitionExtension {
  getCurrentRecommendation(requestingApp: 'STRATEGY_FINDER' | 'PSLF' | 'IDR'): Recommendation {
    const recommendation = this.wellnessTrain.user.recommendations
      .filter(matchesApp(requestingApp))
      .sort(byCreatedAt)
      .at(0);

    if (!recommendation) {
      throw new Error(
        `Missing ${requestingApp} recommendation for WellnessInsightsComponentDefinition ${this.id}`
      );
    }

    return recommendation;
  }
}

const Registration = {
  kind: 'object',
  name: 'wellness-insights-component-definition',
  features: WellnessInsightsComponentDefinitionExtension,
};
export default Registration;
